import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import LoadingScreen from "../LoadingScreen";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const FuelAllocation = () => {
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const [isLoading, setIsloading] = useState(true);
  const [formData, setFormData] = useState({
    fuelVoucherNo: "",
    latestFuelVoucherNo: "",
    firstFuelVoucherNo: "",
    fuelVoucherList: [],
    showFuelVoucher: false,
    searchFuelVoucher: "",
    contractNo: "",
    contractList: [],
    showContracts: false,
    showRoute: false,
    searchContracts: "",
    fuelCriteria: "",
    fuelCriteriaList: [],
    routeNo: "",
    from: "",
    to: "",
    routeList: [],
    searchRoute: "",
    Date: new Date().toISOString(),
    vehicle: "",
    vehicleList: [],
    externalVehicle: false,
    vehicleModel: "",
    driverName: "",
    driverCode: "",
    driverList: [],
    shifts: "",
    vesselName: "",
    shiftNo: 1,
    loadedByThisTruck: "",
    km: "",
    routeKm: "",
    deliveries: "",
    cargo: "",
    customerName: "",
    customerCode: "",
    fuelBal: "",
    fulAmtStd: "",
    approvedAmt: "",
    totalTank: "",
    contractCargoQty: "",
    previousKm: "",
    previousFuelInTank: "",
    currentKm: "",
    kmCovered: "",
    kmLtr: "",
    fuelRate: "",
    currency: "",
    exchRate: "",
    narration: "",
    fromStation: "",
    fromStationList: [],
    subStation: "",
    fuelFitted: false,
    sealNo: "",
    previousSealNo: "",
    standardQty: "",
    isApproved: false,
    isCancelled: false,
    hist: false,
    createdBy: "",
    createdDate: "",
    division: "",
    approvedBy: "",
    approvedDate: "",
    cancelledBy: "",
    cancelledDate: "",
    companyList: {},
    saved: false,
    startdate: "",
    enddate: "",
  });
  const [company, setCompany] = useState({});
  
      const [PopUpReportMM, setPopUpReportMM] = useState(false);
      const [LoadingScreenBlockMM, setLoadingScreenBlockMM] = useState(false);
      const [pdfDataMM, setPdfDataMM] = useState(null);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Filters
  const filtContract = formData?.contractList?.filter((item) => {
    const searchData = formData?.searchContracts
      ?.toLowerCase()
      .split(" ")
      .filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["CONTRACTNO", "CLIENTNAME"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  const filtRoutes = formData?.routeList?.filter((item) => {
    const searchData = formData?.searchRoute
      ?.toLowerCase()
      .split(" ")
      .filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["ROUTEID", "STARTLOC", "ENDLOC"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  // Filter Fuel Voucher
  const filtFuelVoucher = formData?.fuelVoucherList?.filter((item) => {
    const searchData = formData?.searchFuelVoucher
      ?.toLowerCase()
      .split(" ")
      .filter(Boolean);
    const sDate = new Date(item.OT_FUEL_ALLOCATION_DATE);
    const eDate = new Date(item.OT_FUEL_ALLOCATION_DATE);

    const startDate = formData?.startdate ? new Date(formData.startdate) : null;

    const endDate = formData?.enddate ? new Date(formData.enddate) : null;

    // 🔑 Make end date inclusive
    // if (endDate) {
    //   endDate.setHours(23, 59, 59, 999);
    //   }

    const vehicle = formData?.vehicleList?.find(
      (items) =>
        items["VEHICLE REG NO"] === item?.OT_FUEL_ALLOCATION_VEHICLE_REG_NO,
    );

    const route = formData?.routeList?.find(
      (items) => items?.ROUTEID == item?.OT_FUEL_MILEAGE_ROUTE,
    );

    if (searchData.length === 0 && !startDate && !endDate) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      const modelMatch = vehicle?.MODEL?.toLowerCase()?.includes(term) ?? false;

      const otherMatch = [
        "OT_FUEL_ALLOCATION_SEAL_NUMBER",
        "OT_FUEL_ALLOCATION_NO",
        "OT_FUEL_ALLOCATION_VEHICLE_REG_NO",
        "OT_FUEL_MILEAGE_ROUTE",
        "OT_FUEL_ALLOCATION_VEHICLE_DRIVER_NAME",
        "OT_FUEL_ALLOCATION_FROM_LOCATION",
      ].some((key) => {
        const columnValue = String(item[key] || "").toLowerCase();
        return columnValue.includes(term);
      });

      const routeMatch =
        route?.ENDLOC?.toLowerCase()?.includes(term) ||
        route?.STARTLOC?.toLowerCase()?.includes(term);

      return modelMatch || otherMatch || routeMatch;
    });

    const dateMatch =
      (!startDate || sDate >= startDate) && (!endDate || eDate <= endDate);

    return textMatch && dateMatch;
  });

  useEffect(() => {
    getData();
  }, []);

  function getData() {

        axios
      .post(
        `${BASEURL_GLOBAL}/globalGraphQL`,
        {
          query:
            "query ($viewname: String!, $columns: [String!]) { globalView(viewname: $viewname, columns: $columns) }",
          variables: {
            viewname: "1272",
            columns: [
              "OT_FUEL_ALLOCATION_NO",
              "OT_FUEL_ALLOCATION_VEHICLE_REG_NO",
              "OT_FUEL_MILEAGE_ROUTE",
              "OT_FUEL_ALLOCATION_VEHICLE_DRIVER_NAME",
              "OT_FUEL_ALLOCATION_FROM_LOCATION",
              "OT_FUEL_ALLOCATION_SEAL_NUMBER",
              "OT_FUEL_ALLOCATION_DATE",
              "OT_FUEL_ALLOCATION_TO_BE_UTILIZED",
              "OT_FUEL_ALLOCATION_VEHICLE_KM",
              "TOPUP"
            ],
          },
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      )
      .then((res) => {
          const filterData = res?.data?.data?.globalView?.filter((item)=> item.TOPUP === false)
         const sortedData = [...(filterData || [])].sort(
          (a, b) =>
            Number(a.OT_FUEL_ALLOCATION_NO) - Number(b.OT_FUEL_ALLOCATION_NO),
        );
        handleChange(
          "firstFuelVoucherNo",
          sortedData?.[0]?.OT_FUEL_ALLOCATION_NO,
        );
        handleChange("fuelVoucherList", filterData);
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(false);
        console.log("Error While fetching 329", err);
      });


    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=602`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setCompany(res?.data[0]);
        handleChange("companyList", res?.data[0]);
        handleChange(
          "fuelCriteria",
          res?.data[0]?.FUELONKMBASIS === true ? "KM" : "ROUTE",
        );
      })
      .catch((err) => {
        setIsloading(false);
        console.log("Error While fetching Company Details 602", err);
      });

axios
      .post(
        `${BASEURL_GLOBAL}/globalGraphQL`,
        {
          query:
            "query ($viewname: String!, $columns: [String!]) { globalView(viewname: $viewname, columns: $columns) }",
          variables: {
            viewname: "671",
            columns: [
              "TRAILER",
              "VEHICLE REG NO",
              "MAKE",
              "MODEL",
              "DRIVERCODE",
              "DRIVERNAME",
            ],
          },
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
         const filteredData =res?.data?.data?.globalView?.filter(
          (item) => item?.TRAILER === false,
        );
        handleChange("vehicleList", filteredData);
      })
      .catch((err) => {
        setIsloading(false);
        console.log("Error While fetching 1148", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=385`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("fuelVoucherNo", res?.data[0]?.FUELVOUCHERNO);
        handleChange("latestFuelVoucherNo", res?.data[0]?.FUELVOUCHERNO);
      })
      .catch((error) => {
        console.error("Error fetching :", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=358`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("fromStationList", res?.data);
      })
      .catch((error) => {
        console.error("Error fetching 358:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        handleChange("driverList", response?.data);
      })
      .catch((error) => {
        setIsloading(false);
        console.error("Error fetching Driver details:", error);
      });

    // Route List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=524`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("routeList", res?.data);
        // setIsloading(false);
      })
      .catch((err) => {
        setIsloading(false);
        console.log("Error While fetching 524", err);
      });

  }

  async function getKmBasedonRouteAndModel(model, route) {
    var kmLocal = 0;
    await axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1112&OM_FUEL_TRACTOR_TYPE=${model}&OM_FUEL_ROUTE_ID=${route}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        const data = res?.data?.filter(
          (item) => item?.OM_FUEL_KM_BASED === true,
        );
        handleChange(
          "km",
          data[0]?.OM_FUEL_KM_PER_LITRE ? data[0]?.OM_FUEL_KM_PER_LITRE : 0,
        );
        kmLocal = data[0]?.OM_FUEL_KM_PER_LITRE
          ? data[0]?.OM_FUEL_KM_PER_LITRE
          : 0;
      })
      .catch((err) => {
        setIsloading(false);
        console.log("Error While fetching KM Details", err);
      });
    await axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=652&OM_ROUTE_ID=${route}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        handleChange("routeKm", res?.data[0]?.OM_ROUTE_DISTANCE);
        handleChange(
          "approvedAmt",
          kmLocal !== 0
            ? parseFloat(
                Number(res?.data[0]?.OM_ROUTE_DISTANCE) / Number(kmLocal),
              ).toFixed(2)
            : 0,
        );
        handleChange(
          "fulAmtStd",
          kmLocal !== 0
            ? parseFloat(
                Number(res?.data[0]?.OM_ROUTE_DISTANCE) / Number(kmLocal),
              ).toFixed(2)
            : 0,
        );
        handleChange(
          "totalTank",
          kmLocal !== 0
            ? parseFloat(
                Number(res?.data[0]?.OM_ROUTE_DISTANCE) / Number(kmLocal),
              ).toFixed(2) + Number(formData?.fuelBal)
            : 0,
        );
      })
      .catch((error) => {
        console.error("Error fetching 652:", error);
      });
  }

  // ************************ Fetching Transaction Numbers  *******************
  const getFuelRateUponFromStation = (fromStation) => {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandlerFunctionWithParams?viewname=1279&CURRDATE=${moment(
          formData?.Date,
        ).format("YYYY/MM/DD")}&LOCATION=${fromStation}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => handleChange("fuelRate", res?.data[0]?.[""]))
      .catch((err) => console.log("error while fetching the fuel rate", err));
  };

  function getExchangeRate(currency) {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandlerFunctionWithParams?viewname=1278&CURRCODE=${currency}&CURRDATE=${moment(
          new Date(),
        ).format("YYYY/MM/DD")}&COMPCODE=${formData?.companyList?.ORGCODE}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        handleChange("exchRate", res?.data[0]?.[""]);
      })
      .catch((err) => {
        setIsloading(false);
        console.log("Error While fetching 1278", err);
      });
  }

  function getCurrencyUponFromStation(fromStation) {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=567&OM_LOC_CODE=${fromStation}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        handleChange("currency", res?.data[0]?.OM_LOCATION_CURRENCY);
        getExchangeRate(res?.data[0]?.OM_LOCATION_CURRENCY);
        setIsloading(false);
      })
      .catch((error) => {
        console.error("Error fetching 567:", error);
      });
  }

  // ************************ Saving **************************************

  async function getNewVoucherNo() {
    await axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=385`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("fuelVoucherNo", res?.data[0]?.FUELVOUCHERNO);
        handleChange("latestFuelVoucherNo", res?.data[0]?.FUELVOUCHERNO);
      })
      .catch((error) => {
        console.error("Error fetching :", error);
      });
  }

  async function SaveFuelVoucher() {
    if (!formData?.fuelVoucherNo) {
      alert("Please provide Fuel Voucher No");
      return;
    }

    if (formData?.externalVehicle) {
      if (!formData?.vehicle) {
        alert("Please Select Vehicle");
        return;
      }

      if (!formData?.driverName) {
        alert("Please Select Driver");
        return;
      }

      if (!formData?.approvedAmt) {
        alert("Please Provide Approved Amount");
        return;
      }

      if (!formData?.fromStation) {
        alert("Please provide From Station");
        return;
      }

      if (!formData?.narration) {
        alert("Please provide Narration");
        return;
      }
    } else {
      if (!formData?.from) {
        alert("Please Select Route");
        return;
      }

      if (!formData?.vehicle) {
        alert("Please Select Vehicle");
        return;
      }

      if (!formData?.fuelBal) {
        alert("Please Provide Fuel Bal");
        return;
      }

      if (!formData?.fromStation) {
        alert("Please provide From Station");
        return;
      }

      if (!formData?.narration) {
        alert("Please provide Narration");
        return;
      }

      if (!formData?.fuelFitted) {
        alert("Please Check Fuel Fitted");
        return;
      }

      if (!formData?.sealNo) {
        alert("Kindly supply Seal No");
        return;
      }

      if (!formData?.currentKm) {
        alert("Please provide Current KM");
        return;
      }
    }

    // await axios
    //   .get(`${BASEURL_GLOBAL}/globalSearchHandlerLimit?viewname=1272&sortBy=OT_FUEL_ALLOCATION_NO`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessiontoken,
    //     },
    //   })
    //   .then(async (res) => {
    //     const sortedData = [...(res?.data || [])].sort(
    //       (a, b) =>
    //         Number(b.OT_FUEL_ALLOCATION_NO) - Number(a.OT_FUEL_ALLOCATION_NO),
    //     );

    //     const isVoucherAvailable = sortedData?.find(
    //       (item) =>
    //         item?.OT_FUEL_ALLOCATION_NO === Number(formData?.fuelVoucherNo),
    //     );
    //     if (
    //       isVoucherAvailable &&
    //       sortedData[0]?.OT_FUEL_ALLOCATION_NO > formData?.latestFuelVoucherNo
    //     ) {
    //       await getNewVoucherNo();
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching 1272:", error);
    //   });

    try {
      setIsloading(true);
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1271`,
        {
          // CONTRACTNO: Number(formData?.contractNo),
          CONTRACTNO: 0,
          FUELVOUCHERNO: Number(formData?.fuelVoucherNo),
          JOURNEYNO: 0,
          JOBTYPE: "",
          ISSUEDATE: moment(formData?.Date).format("YYYY/MM/DD"),
          TRUCK: formData?.vehicle,
          DRIVERCODE: formData?.driverCode ? formData?.driverCode : "",
          DRIVERNAME: formData.driverName ? formData.driverName : "",
          VEHICLEMODEL: formData?.vehicleModel ? formData?.vehicleModel : "",
          TRAILERTYPE: "",
          // TRAILERCATEGORY: formData?.cargo ? formData?.cargo : "",
          TRAILERCATEGORY: "",
          FUELQTYTOBEUTILIZED: formData?.fulAmtStd
            ? Number(formData?.fulAmtStd)
            : 0,
          FUELQTY: formData?.approvedAmt ? Number(formData?.approvedAmt) : 0,
          NARRATION: formData?.narration ? formData?.narration : "",
          LOCATION: formData?.fromStation ? formData?.fromStation : "",
          FUELRATE: Number(formData?.fuelRate),
          KM: formData?.currentKm ? Number(formData?.currentKm) : 0,
          CREATEDBY: user,
          DIVISION: "",
          CURRENCY: formData?.currency ? formData?.currency : "",
          EXCHRATE: formData?.exchRate ? Number(formData?.exchRate) : 0,
          SUBCONTRACTED: 0,
          SUBCONTRACTORCODE: 0,
          ROUTEID: formData?.routeNo ? Number(formData?.routeNo) : 0,
          FUELSTATION: formData?.fromStation ? formData?.fromStation : "",
          TOPUP: 0,
          FUELBALANCE: formData?.fuelBal ? Number(formData?.fuelBal) : 0,
          CRITERIA: formData?.km ? 1 : 0,
          ROUTEKM: formData?.routeKm ? Number(formData?.routeKm) : 0,
          KMPERLITRE: formData?.km ? Number(formData?.km) : 0,
          FUELLOCKFITTED: formData?.fuelFitted === true ? 1 : 0,
          SEALNO: formData?.sealNo ? formData?.sealNo : "",
          TOPUPREASON: "",
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
          NEWEXISTING: formData?.hist === true ? "EXISTING" : "NEW",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );
      if (response.status === 201) {
        alert("Standard Fuel Issued Successfully");
        // window.location.reload();
        handleChange("saved", true);
      } else {
        alert("Error while Issuing Standard Fuel");
      }
      setIsloading(false);
    } catch (err) {
      alert("Error while Issuing Standard Fuel");
      setIsloading(false);
    }
  }

  const handleButtonClick = (action) => {
    let fuelVoucherToPass;
    switch (action) {
      case "first":
        fuelVoucherToPass = Number(formData?.firstFuelVoucherNo);
        break;
      case "decrement":
        fuelVoucherToPass = Number(formData?.fuelVoucherNo) - 1;
        if (fuelVoucherToPass < Number(formData?.firstFuelVoucherNo)) {
          alert("Cannot decrement further");
          return;
        }
        break;

      case "increment":
        fuelVoucherToPass = Number(formData?.fuelVoucherNo) + 1;
        if (fuelVoucherToPass >= Number(formData?.latestFuelVoucherNo)) {
          alert("No Further PO number");
          return;
        }
        break;

      case "latest":
        fuelVoucherToPass = Number(formData?.latestFuelVoucherNo) - 1;
        break;
      default:
        break;
    }

    handleChange("fuelVoucherNo", fuelVoucherToPass);
    getNavData(fuelVoucherToPass);
  };

  async function getNavData(fuelVoucher) {
    setIsloading(true);
    try {
      const res = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1272&OT_FUEL_ALLOCATION_NO=${fuelVoucher}&TOPUP=false`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (res?.data?.length > 0) {
        handleChange("saved", true);
        const item = res?.data[0];
        handleChange("fuelVoucherNo", item?.OT_FUEL_ALLOCATION_NO);
        // handleChange("contractNo", item?.OT_FUEL_ALLOCATION_JOB_NO);
        handleChange(
          "fuelCriteria",
          item?.OT_FUEL_ALLOCATION_KM_BASED === true ? "KM" : "ROUTE",
        );
        handleChange("routeNo", item?.OT_FUEL_MILEAGE_ROUTE);
        const route = formData?.routeList?.find(
          (items) => items?.ROUTEID == item?.OT_FUEL_MILEAGE_ROUTE,
        );
        handleChange("from", route?.STARTLOC);
        handleChange("to", route?.ENDLOC);

        handleChange("Date", item?.OT_FUEL_ALLOCATION_DATE);
        handleChange("vehicle", item?.OT_FUEL_ALLOCATION_VEHICLE_REG_NO);
        const vehicle = formData?.vehicleList?.find(
          (items) =>
            items["VEHICLE REG NO"] === item?.OT_FUEL_ALLOCATION_VEHICLE_REG_NO,
        );
        handleChange("vehicleModel", vehicle?.MODEL);
        handleChange(
          "driverName",
          item?.OT_FUEL_ALLOCATION_VEHICLE_DRIVER_NAME,
        );
        handleChange(
          "driverCode",
          item?.OT_FUEL_ALLOCATION_VEHICLE_DRIVER_CODE,
        );
        handleChange("km", item?.OT_FUEL_ALLOCATION_LITRES_PER_KM);
        handleChange("routeKm", item?.OT_FUEL_ALLOCATION_KM_TO_COVER);
        // const contract = formData?.contractList?.find(
        //   (items) => items?.CONTRACTNO === item?.OT_FUEL_ALLOCATION_JOB_NO
        // );
        // handleChange("customerCode", contract?.CLIENT);
        // handleChange("customerName", contract?.CLIENTNAME);
        // handleChange("contractCargoQty", contract?.CARGOTOTALQTYORWEIGHT);
        // handleChange("cargo", contract?.CARGOCATEGORY);
        handleChange("totalTank", item?.OT_FUEL_ALLOCATION_TOTAL_IN_TANK);
        handleChange("fuelBal", item?.OT_FUEL_ALLOCATION_INITIAL_READING);
        handleChange("approvedAmt", item?.OT_FUEL_ALLOCATION_FINAL_AMOUNT);
        handleChange("fulAmtStd", item?.OT_FUEL_ALLOCATION_TO_BE_UTILIZED);
        handleChange("fromStation", item?.OT_FUEL_SUB_STATION);
        handleChange("narration", item?.OT_FUEL_ALLOCATION_NARRATION);
        handleChange("currency", item?.OT_FUEL_CURRENCY);
        handleChange("exchRate", item?.OT_FUEL_EXCH_RATE);
        handleChange("fuelRate", item?.OT_FUEL_ALLOCATION_RATE);
        handleChange("createdBy", item?.OT_FUEL_ALLOCATION_CREATED_BY);
        handleChange("createdDate", item?.OT_FUEL_ALLOCATION_CREATED_DATE);
        handleChange("isApproved", item?.OT_FUEL_ALLOCATION_APPROVED);
        handleChange("approvedBy", item?.OT_FUEL_ALLOCATION_APPROVED_BY);
        handleChange("approvedDate", item?.OT_FUEL_ALLOCATION_APPROVAL_TIME);
        handleChange("isCancelled", item?.OT_FUEL_ALLOCATION_CANCELLED);
        handleChange("cancelledBy", item?.OT_FUEL_ALLOCATION_CANCELLED_BY);
        handleChange("cancelledDate", item?.OT_FUEL_ALLOCATION_CANCELLED_DATE);
        handleChange("sealNo", item?.OT_FUEL_ALLOCATION_SEAL_NUMBER);
        handleChange("fuelFitted", item?.OT_FUEL_LOCK_FITTED);
        handleChange("currentKm", item?.OT_FUEL_ALLOCATION_VEHICLE_KM);
        await getPreviousSealNo(
          item?.OT_FUEL_ALLOCATION_VEHICLE_REG_NO,
          item?.OT_FUEL_ALLOCATION_NO,
        );
        handleChange("hist", true);
      } else {
        // Auto-decrement if record not found
        const allVouchers = [...(formData?.fuelVoucherList || [])]
          .map((item) => Number(item?.OT_FUEL_ALLOCATION_NO))
          .sort((a, b) => a - b);

        const currentVoucher = Number(fuelVoucher);

        // Determine whether this was likely an increment or decrement action
        const lastVoucherNo = Number(formData?.fuelVoucherNo);

        const isIncrement = currentVoucher > lastVoucherNo;

        if (isIncrement) {
          // Find next existing record greater than the current one
          const nextExisting = allVouchers.find((num) => num > currentVoucher);
          if (nextExisting !== undefined) {
            console.warn(
              `Fuel Voucher ${fuelVoucher} not found, trying ${nextExisting}`,
            );
            await getNavData(nextExisting);
            return;
          } else {
            alert(`No further Fuel Voucher found after ${fuelVoucher}`);
          }
        } else {
          const previousExisting = [...allVouchers]
            .reverse()
            .find((num) => num < Number(fuelVoucher));

          if (previousExisting !== undefined) {
            console.warn(
              `Fuel Voucher ${fuelVoucher} not found, trying ${previousExisting}`,
            );
            await getNavData(previousExisting);
            return;
          } else {
            alert(`No existing Fuel Voucher found before ${fuelVoucher}`);
          }
        }
      }
    } catch (err) {
      console.error("Error While fetching 1272", err);
    } finally {
      setIsloading(false);
    }
  }

  async function getPreviousSealNo(vehicle, fuelvoucher) {
    try {
      const result = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1272&OT_FUEL_ALLOCATION_VEHICLE_REG_NO=${vehicle}&TOPUP=false`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );
      let rows = result?.data || [];

      if (rows.length === 0) {
        handleChange("previousSealNo", "No Seal No");
        return;
      }

      // 1️⃣ Sort all vouchers for that vehicle in DESC order (latest → oldest)
      rows.sort(
        (a, b) =>
          Number(b.OT_FUEL_ALLOCATION_NO) - Number(a.OT_FUEL_ALLOCATION_NO),
      );

      // 2️⃣ Find the current voucher index
      const currentIndex = rows.findIndex(
        (v) => Number(v.OT_FUEL_ALLOCATION_NO) === Number(fuelvoucher),
      );

      // 3️⃣ Previous voucher = next index in sorted array
      const previousRow = rows[currentIndex + 1];

      if (previousRow) {
        handleChange(
          "previousSealNo",
          previousRow?.OT_FUEL_ALLOCATION_SEAL_NUMBER || "No Seal No",
        );
      }
    } catch (err) {
      console.error("Error While fetching 1272", err);
    }
  }

  async function ApproveAmmendCancelFuelVoucher(type) {
    if (formData?.fuelVoucherNo === formData?.latestFuelVoucherNo) {
      alert(`Please Select the Saved Fuel To ${type}`);
      return;
    }

    if (type === "APPROVE") {
      if (formData?.isApproved) {
        alert(`This voucher no ${formData?.fuelVoucherNo} is already approved`);
        return;
      }
      if (formData?.isCancelled) {
        alert(
          `This voucher no ${formData?.fuelVoucherNo} is cancelled , can not Approve`,
        );
        return;
      }
    }

    if (type === "CANCEL") {
      if (formData?.isCancelled) {
        alert(
          `This voucher no ${formData?.fuelVoucherNo} is already cancelled`,
        );
        return;
      }
      if (formData?.isApproved) {
        alert(
          `This voucher no ${formData?.fuelVoucherNo} is approved , can not Cancel`,
        );
        return;
      }
    }

    if (type === "AMEND") {
      if (!formData?.isApproved) {
        alert(`This voucher no ${formData?.fuelVoucherNo} is not yet approved`);
        return;
      }

      if (formData?.isCancelled) {
        alert(
          `This voucher no ${formData?.fuelVoucherNo} is cancelled , can not Ammend`,
        );
        return;
      }
    }

    try {
      setIsloading(true);
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1273`,
        {
          FUELVOUCHERNO: formData?.fuelVoucherNo
            ? Number(formData?.fuelVoucherNo)
            : 0,
          TRANSTYPE: type,
          AMOUNT: formData?.approvedAmt ? Number(formData?.approvedAmt) : 0,
          APPROVEDBY: user ? user : "",
          APPROVEDDATE: moment(new Date()).format("YYYY/MM/DD"),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );
      if (response.status === 201) {
        alert(`Fuel Voucher ${type} Successfull`);
        window.location.reload();
      } else {
        alert(`Error In ${type} Of Fuel Voucher`);
      }
      setIsloading(false);
      window.location.reload();
    } catch (err) {
      alert(`Error In ${type} Of Fuel Voucher`);
      setIsloading(false);
    }
  }

  // *************** EXPORT TO EXCEL OR PDF ****************************
  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("FUEL VOUCHER PROCESSING-LS");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [10, 15, 15, 25, 10, 25, 25, 25, 10, 10];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "FUEL VOUCHER NO",
      "FUEL VOUCHER DATE",
      "VEHICLE",
      "VEHICLE MODEL",
      "DRIVER NAME",
      "ROUTE NO",
      "FROM",
      "TO",
      "FROM STATION",
      "SEAL NO",
      "ACTUAL AMOUNT ISSUED",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "FUEL_VOUCHER_PROCESSING_LS.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    const doc = new jsPDF();

    doc.text("FUEL VOUCHER PROCESSING-LS - Report", 10, 10);

    const columns = [
      "FUEL VOUCHER NO",
      "FUEL VOUCHER DATE",
      "VEHICLE",
      "VEHICLE MODEL",
      "DRIVER NAME",
      "ROUTE NO",
      "FROM",
      "TO",
      "FROM STATION",
      "SEAL NO",
      "ACTUAL AMOUNT ISSUED",
    ];

    const data = filtFuelVoucher.map((stock) => {
      const vehicle = formData?.vehicleList?.find(
        (items) =>
          items["VEHICLE REG NO"] === stock?.OT_FUEL_ALLOCATION_VEHICLE_REG_NO,
      );
      const route = formData?.routeList?.find(
        (items) => items?.ROUTEID == stock?.OT_FUEL_MILEAGE_ROUTE,
      );

      return [
        stock.OT_FUEL_ALLOCATION_NO,
        stock.OT_FUEL_ALLOCATION_DATE
          ? moment(stock.OT_FUEL_ALLOCATION_DATE).format("DD/MM/YYYY")
          : "",
        ,
        stock.OT_FUEL_ALLOCATION_VEHICLE_REG_NO,
        vehicle?.MODEL,
        stock.OT_FUEL_ALLOCATION_VEHICLE_DRIVER_NAME,
        stock.OT_FUEL_MILEAGE_ROUTE,
        route?.STARTLOC,
        route?.ENDLOC,
        stock.OT_FUEL_ALLOCATION_FROM_LOCATION,
        stock.OT_FUEL_ALLOCATION_SEAL_NUMBER,
        stock.OT_FUEL_ALLOCATION_TO_BE_UTILIZED,
      ];
    });

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("FUEL_VOUCHER_PROCESSING_LS.pdf");
  };


    // Generate Report Date 
     function generateReportMM() {
      setPdfDataMM(null);
      const endDataFormat =
        formData?.enddate.slice(8, 10) +
        "/" +
        formData?.enddate.slice(5, 7) +
        "/" +
         formData?.enddate.slice(0, 4);
           const startDataFormat =
        formData?.startdate.slice(8, 10) +
        "/" +
        formData?.startdate.slice(5, 7) +
        "/" +
        formData?.startdate.slice(0, 4);
      console.log(endDataFormat);
      setLoadingScreenBlockMM(true);
  
      axios
        .post(
          `${BASEURL}/generatereport`,
          {
            REPORTNAME: "CrMonthtoDateFuelDetailedReport.rpt",
            STARTDATE: startDataFormat,
            ENDDATE: endDataFormat,
            DIVISIONBASED: "NO",
            DIVISIONNAME: "",
            SINGLEMULTIDATE: "Date Range",
            REPORTPATH: company?.REPORTPATH,
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
            responseType: "blob", // Important for handling binary data
            timeout: 60000, // Set timeout to 60 seconds (60000 milliseconds)
          },
        )
        .then((res) => {
          console.log(res);
          const file = new Blob([res.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          setPdfDataMM(fileURL);
          setLoadingScreenBlockMM(false);
        })
        .catch((err) => {
          console.log("Error generating report:", err);
          setLoadingScreenBlockMM(false);
        });
    }
  
    const handleDownloadMM = () => {
      const a = document.createElement("a");
      a.href = pdfDataMM;
      a.download = "generated_report.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };

  if (isLoading) {
    return <LoadingScreen />;
  }
  return (
    <div>
      <section className="block print:hidden text-xs">
        <AllPagesNavbar />
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          FUELVOUCHERPROCESSING-LS
        </h1>

        {/* Status Line  */}
        {formData?.hist === true && (
          <div className="flex ml-2 gap-1 mb-2">
            <p className="font-bold">Created By:</p>
            <span className="text-red-500">{formData?.createdBy}</span>
            <p className="font-bold">|</p>
            <p className="font-bold">Created Date:</p>
            <span className="text-red-500">
              {moment(formData?.createdDate).format("DD/MM/YYYY")}
            </span>
            <p className="font-bold">|</p>
            <p className="font-bold">Approval Status:</p>
            <span className="text-red-500">
              {formData?.isApproved === true ? "APPROVED" : "NOT APPROVED"}
            </span>
            <p className="font-bold">|</p>
            {formData?.isApproved === true && (
              <>
                <p className="font-bold">Approved By:</p>
                <span className="text-red-500">{formData?.approvedBy}</span>
                <p className="font-bold">|</p>
                <p className="font-bold">Approved Date:</p>
                <span className="text-red-500">
                  {formData?.approvedDate
                    ? moment(formData?.approvedDate).format("DD/MM/YYYY")
                    : ""}
                </span>
                <p className="font-bold">|</p>
              </>
            )}
            <p className="font-bold">Cancellation Status:</p>
            <span className="text-red-500">
              {formData?.isCancelled === true ? "CANCELLED" : "NOT CANCELLED"}
            </span>
            <p className="font-bold">|</p>
            {formData?.isCancelled === true && (
              <>
                <p className="font-bold">Cancelled By:</p>
                <span className="text-red-500">{formData?.cancelledBy}</span>
                <p className="font-bold">|</p>
                <p className="font-bold">Cancelled Date:</p>
                <span className="text-red-500">
                  {formData?.cancelledDate
                    ? moment(formData?.cancelledDate).format("DD/MM/YYYY")
                    : ""}
                </span>
              </>
            )}
          </div>
        )}

        {/* Buttons */}
        <aside className="lg:flex justify-between pr-2 gap-2 mt-1 mb-1">
          <div className="flex">
            <div className="flex lg:ml-2 gap-1 lg:mr-2">
              <button
                className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  handleButtonClick("first");
                }}
              >
                {"<<"}
              </button>
              <button
                className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  handleButtonClick("decrement");
                }}
              >
                {"<"}
              </button>
              <button
                className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  handleButtonClick("increment");
                }}
              >
                {">"}
              </button>
              <button
                className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  handleButtonClick("latest");
                }}
              >
                {">>"}
              </button>
            </div>

            <button
              className="border h-7 border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                window.location.reload();
              }}
            >
              New Voucher
            </button>

            <button
              className="border h-7 border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                if (formData?.hist === true) {
                  getNewVoucherNo();
                  handleChange("hist", false)
                  handleChange("saved", false);
                } else {
                  alert("Kindly save this Voucher No");
                }
              }}
            >
              Duplicate and New
            </button>

            <button
              className="h-7 border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                if (formData?.saved === false) {
                  await SaveFuelVoucher();
                } else {
                  alert("This Voucher is Saved");
                  return;
                }
              }}
            >
              Save
            </button>

            <button
              className="h-7 border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                await ApproveAmmendCancelFuelVoucher("APPROVE");
              }}
            >
              Approve
            </button>

            <button
              className="h-7  border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                if (formData?.hist === false) {
                  alert("This Transaction not yet Saved");
                } else if (formData?.isApproved === false) {
                  alert("This Transaction not yet Approved");
                } else {
                  window.print();
                }
              }}
            >
              Print
            </button>

            <button
              className="h-7  border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                await ApproveAmmendCancelFuelVoucher("AMEND");
              }}
            >
              Ammend
            </button>

            <button
              className="h-7  border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                await ApproveAmmendCancelFuelVoucher("CANCEL");
              }}
            >
              Cancel
            </button>
          </div>
        </aside>
        {/* Headers */}
        <div className="bg-slate-100 m-1 rounded-md p-1 pb-2 h-auto">
          {/* First Line */}
          <div className="lg:flex mt-2">
            <span className="lg:ml-1 block">Fuel Voucher No :</span>
            <input
              readOnly
              className="w-20 h-7 lg:ml-2 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.fuelVoucherNo}
            ></input>
            <button
              className="  border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-1 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                handleChange("showFuelVoucher", true);
              }}
            >
              ...
            </button>

            {formData?.showFuelVoucher && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={formData?.searchFuelVoucher}
                    onChange={(e) => {
                      handleChange("searchFuelVoucher", e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">Start Date:</p>
                  <input
                    className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={formData?.startdate?.split("T")[0]}
                    onChange={(e) => {
                      handleChange("startdate", e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">End Date:</p>
                  <input
                    className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={formData?.enddate?.split("T")[0]}
                    onChange={(e) => {
                      handleChange("enddate", e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-20 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={async () => {
                    if (!formData?.startdate) {
                      alert("Kindly Provide Start date")
                    } else if (!formData?.enddate) {
                      alert("Kindly Provide End date")
                    } else {
                      setPopUpReportMM(true);
                      await generateReportMM();
                    }
                    }}
                >
                  Print Fuel Report
                </button>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => handleChange("showFuelVoucher", false)}
                >
                  Close
                </button>


                
              {PopUpReportMM && (
                        <div>
                          <div
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                              zIndex: 99,
                            }}
                          />
            
                          {/* Popup */}
                          <div
                            style={{
                              position: "fixed",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              backgroundColor: "white",
                              border: "1px solid black",
                              height: "80%",
                              width: "90%",
                              maxWidth: "90%",
                              maxHeight: "600px",
                              padding: "16px",
                              zIndex: 100,
                              overflowY: "auto",
                              borderRadius: "8px",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            {LoadingScreenBlockMM && <LoadingScreen />}
                            <button
                              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                              onClick={() => setPopUpReportMM(false)}
                            >
                              Close
                            </button>
                            <section className="lg:flex lg:flex-col bg-white p-4 gap-2 shadow-lg rounded-md w-full min-h-[500px]">
                              <div>
                                <section className="lg:hidden block">
                                  {pdfDataMM && (
                                    <button
                                      className="bg-blue-500 text-white rounded-md px-2 py-1 block my-1"
                                      onClick={handleDownloadMM}
                                    >
                                      Download PDF
                                    </button>
                                  )}
                                </section>
                                <section className="lg:block">
                                  {pdfDataMM ? (
                                    <div className="mt-4">
                                      <h2 className="text-lg font-bold">
                                        Generated Report
                                      </h2>
                                      <object
                                        key={pdfDataMM}
                                        data={pdfDataMM}
                                        title="Generated Report"
                                        width="100%"
                                        height="600px"
                                      />
                                    </div>
                                  ) : (
                                    <p className="text-2xl font-bold my-4 text-center">
                                      No report available.
                                    </p>
                                  )}
                                </section>
                              </div>
                            </section>
                          </div>
                        </div>
                      )}

                <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
                  <div className="flex justify-end gap-2">
                    <div className="cursor-pointer">
                      <RiFileExcel2Line onClick={ExcelStockData} size={25} />
                    </div>
                    <div className="cursor-pointer">
                      <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
                    </div>
                  </div>
                  <table className="w-full border border-gray-300 text-sm table_1">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px] table-header">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          FUEL VOUCHER NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          FUEL VOUCHER DATE
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          VEHICLE
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          VEHICLE MODEL
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          DRIVER NAME
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          ROUTE NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          FROM
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          TO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          FROM STATION
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          SEAL NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          ACTUAL AMOUNT ISSUED
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtFuelVoucher?.map((item, index) => {
                        const vehicle = formData?.vehicleList?.find(
                          (items) =>
                            items["VEHICLE REG NO"] ===
                            item?.OT_FUEL_ALLOCATION_VEHICLE_REG_NO,
                        );
                        const route = formData?.routeList?.find(
                          (items) =>
                            items?.ROUTEID == item?.OT_FUEL_MILEAGE_ROUTE,
                        );
                        return (
                          <tr
                            className="hover:bg-gray-100 cursor-pointer text-[13px]"
                            onClick={() => {
                              getNavData(item?.OT_FUEL_ALLOCATION_NO);
                              handleChange("showFuelVoucher", false);
                            }}
                            key={index}
                          >
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item.OT_FUEL_ALLOCATION_NO
                                ? item.OT_FUEL_ALLOCATION_NO
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item.OT_FUEL_ALLOCATION_DATE
                                ? moment(item.OT_FUEL_ALLOCATION_DATE).format(
                                    "DD/MM/YYYY",
                                  )
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item.OT_FUEL_ALLOCATION_VEHICLE_REG_NO
                                ? item.OT_FUEL_ALLOCATION_VEHICLE_REG_NO
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {vehicle?.MODEL ? vehicle?.MODEL : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item.OT_FUEL_ALLOCATION_VEHICLE_DRIVER_NAME
                                ? item.OT_FUEL_ALLOCATION_VEHICLE_DRIVER_NAME
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item.OT_FUEL_MILEAGE_ROUTE
                                ? item.OT_FUEL_MILEAGE_ROUTE
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {route?.STARTLOC ? route?.STARTLOC : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {route?.ENDLOC ? route?.ENDLOC : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item.OT_FUEL_ALLOCATION_FROM_LOCATION
                                ? item.OT_FUEL_ALLOCATION_FROM_LOCATION
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item.OT_FUEL_ALLOCATION_SEAL_NUMBER
                                ? item.OT_FUEL_ALLOCATION_SEAL_NUMBER
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item.OT_FUEL_ALLOCATION_TO_BE_UTILIZED
                                ? item.OT_FUEL_ALLOCATION_TO_BE_UTILIZED?.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )
                                : "NA"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* <span className="lg:ml-1 block">Contract No :</span>
            <input
              readOnly
              className="w-20 h-7 lg:ml-2 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.contractNo}
            ></input>
            <button
              className="  border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                handleChange("showContracts", true);
              }}
            >
              ...
            </button>

            {formData?.showContracts && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={formData?.searchContracts}
                    onChange={(e) => {
                      handleChange("searchContracts", e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => handleChange("showContracts", false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
                  <table className="w-full border border-gray-300 text-sm">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px]">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          CONTRACT NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          CUSTOMER
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtContract?.map((item, index) => (
                        <tr
                          className="hover:bg-gray-100 cursor-pointer text-[13px]"
                          onClick={() => {
                            handleChange("contractNo", item?.CONTRACTNO);
                            handleChange("customerCode", item?.CLIENT);
                            handleChange("customerName", item?.CLIENTNAME);
                            // handleChange("from", item?.ROUTEFROM);
                            // handleChange("to", item?.ROUTETO);
                            // handleChange("routeNo", item?.ROUTEID);
                            handleChange("cargo", item?.CARGO);
                            getRoutesBasedOnContract(item?.CONTRACTNO);
                            // handleChange("narration", item?.NOTES);
                            // handleChange(
                            //   "contractCargoQty",
                            //   item?.CARGOTOTALQTYORWEIGHT
                            // );
                            handleChange("showContracts", false);
                          }}
                        >
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.CONTRACTNO ? item.CONTRACTNO : "NA"}
                          </td>
                          <td className="py-2 px-4 border border-gray-300">
                            {item.CLIENTNAME ? item.CLIENTNAME : "N/A"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )} */}

            <button
              className="  border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-1 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                // if (formData?.contractNo) {
                handleChange("showRoute", true);
                // } else {
                //   alert("Kindly select the contract no first");
                // }
              }}
            >
              Route
            </button>

            {formData?.showRoute && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={formData?.searchRoute}
                    onChange={(e) => {
                      handleChange("searchRoute", e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => handleChange("showRoute", false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
                  <table className="w-full border border-gray-300 text-sm">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px]">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          ROUTE ID
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          FROM
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          TO
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtRoutes?.map((item, index) => (
                        <tr
                          className="hover:bg-gray-100 cursor-pointer text-[13px]"
                          onClick={async () => {
                            handleChange("from", item?.STARTLOC);
                            handleChange("to", item?.ENDLOC);
                            handleChange("routeNo", item?.ROUTEID);
                            // handleChange(
                            //   "contractCargoQty",
                            //   item?.CARGOTOTALQTYORWEIGHT
                            // );

                            if (formData?.vehicle) {
                              const vehicle = formData?.vehicleList?.find(
                                (item) =>
                                  item["VEHICLE REG NO"] === formData?.vehicle,
                              );
                              await getKmBasedonRouteAndModel(
                                vehicle?.MODEL,
                                formData?.routeNo,
                              );
                              await getPreviousSealNo(
                                formData?.vehicle,
                                formData?.fuelVoucherNo,
                              );
                            }

                            handleChange("showRoute", false);
                          }}
                        >
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.ROUTEID ? item.ROUTEID : "NA"}
                          </td>
                          <td className="py-2 px-4 border border-gray-300">
                            {item.STARTLOC ? item.STARTLOC : "N/A"}
                          </td>
                          <td className="py-2 px-4 border border-gray-300">
                            {item.ENDLOC ? item.ENDLOC : "NA"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <span className="lg:ml-2 mr-2 block">Fuel Criteria :</span>
            <Select
              className="w-28"
              value={
                formData?.fuelCriteria
                  ? {
                      value: formData?.fuelCriteria,
                      label: formData?.fuelCriteria,
                    }
                  : { value: "", label: "Select Fuel Criteria" }
              }
              // onChange={(e) => handleChange("fuelCriteria", e.value)}
              // options={[
              //   { value: "", label: "Select Fuel Criteria" },
              //   { value: "ROUTE", label: "ROUTE" },
              // ]}
            ></Select>
            <span className="mx-2 block">From :</span>
            <input
              readOnly
              className="w-48 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.from}
            ></input>

            <span className="mx-2 block">To :</span>
            <input
              readOnly
              className="w-48 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.to}
            ></input>

            <span className="lg:ml-1">Date :</span>
            <input
              type="date"
              className="w-28 h-7 lg:ml-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.Date?.split("T")[0]}
              onChange={(e) => handleChange("Date", e.target.value)}
            ></input>
          </div>

          {/* 2nd line  */}
          <div className="lg:flex mt-2">
            <span className="lg:ml-1 block">Vehicle :</span>
            {formData?.externalVehicle === true ? (
              <input
                className="w-44 h-7 lg:ml-14 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                value={formData?.vehicle}
                onChange={(e) => handleChange("vehicle", e.target.value)}
              ></input>
            ) : (
              <Select
                className="w-44 lg:ml-14"
                value={
                  formData?.vehicle
                    ? { value: formData?.vehicle, label: formData?.vehicle }
                    : { value: "", label: "Select Vehicle" }
                }
                onChange={async (e) => {
                  if (!formData?.routeNo) {
                    alert("Kindly Select the route details");
                  } else {
                    if (e.value !== "") {
                      handleChange("vehicle", e.value);
                      const vehicle = formData?.vehicleList?.find(
                        (item) => item["VEHICLE REG NO"] === e.value,
                      );
                      // handleChange("vehicleMake", vehicle?.MAKE);
                      handleChange("vehicleModel", vehicle?.MODEL);
                      handleChange("driverCode", vehicle?.DRIVERCODE);
                      handleChange("driverName", vehicle?.DRIVERNAME);
                      // handleChange("trailer", vehicle?.["TRAILER NAME ATTACHED"]);
                      await getKmBasedonRouteAndModel(
                        vehicle?.MODEL,
                        formData?.routeNo,
                      );
                      // getJourneyUponVehicle(e.value);
                      await getPreviousSealNo(e.value, formData?.fuelVoucherNo);
                      const prev = formData?.fuelVoucherList
                        ?.filter(
                          (item) =>
                            item?.OT_FUEL_ALLOCATION_VEHICLE_REG_NO === e.value,
                        )
                        .sort(
                          (a, b) =>
                            a?.OT_FUEL_ALLOCATION_NO - b?.OT_FUEL_ALLOCATION_NO,
                        );
                      console.log(prev);
                      handleChange(
                        "previousKm",
                        prev?.length > 0
                          ? prev[prev?.length - 1]
                              ?.OT_FUEL_ALLOCATION_VEHICLE_KM
                          : 0,
                      );
                    } else {
                      handleChange("vehicle", e.value);
                    }
                  }
                }}
                options={[
                  { value: "", label: "Select Vehicle" },
                  ...formData?.vehicleList?.map((item) => ({
                    value: item["VEHICLE REG NO"],
                    label: item["VEHICLE REG NO"],
                  })),
                ]}
              ></Select>
            )}
            <span className="block lg:ml-2">External Vehicle :</span>
            <input
              type="checkbox"
              className="w-5 h-5 lg:ml-2 mt-1"
              checked={formData?.externalVehicle}
              onChange={() =>
                handleChange("externalVehicle", !formData?.externalVehicle)
              }
            ></input>

            <span className="block lg:ml-2">Vehicle Model :</span>
            <input
              readOnly
              className="w-40 h-7 lg:ml-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.vehicleModel}
            ></input>
            {/* <span className="mx-2 block">Shifts :</span>
            <input
              readOnly
              className="w-32 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.shifts}
            ></input> */}
            <span className="lg:ml-2 block">Driver :</span>
            {/* {formData?.driverName ? (
              <input
                readOnly
                className="w-80 h-7 lg:ml-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                value={formData?.driverName}
              ></input>
            ) : (
             
            )} */}
            <Select
              className="lg:w-56 lg:ml-2"
              value={
                formData?.driverName
                  ? {
                      value: formData?.driverName,
                      label: formData?.driverName,
                    }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                handleChange("driverName", e.label);
                handleChange("driverCode", e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...(Array.isArray(formData?.driverList)
                  ? formData.driverList.map((item) => ({
                      value: item?.DRIVERCODE,
                      label: item?.DRIVERNAME,
                    }))
                  : []),
              ]}
            ></Select>
            <span className="mx-2 block">KM/Ltr :</span>
            <input
              className="w-28 h-7 border text-right border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.km}
              // onChange={(e) => handleChange("km", e.target.value)}
              readOnly
            ></input>
            <span className="mx-2 block">Route KM :</span>
            <input
              className="w-32 h-7 border text-right border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.routeKm}
              readOnly
              // onChange={(e) => handleChange("routeKm", e.target.value)}
            ></input>
          </div>

          {/* 3rd Line  */}
          <div className="lg:flex mt-2">
            {/* <span className="lg:ml-1 block">Vessel Name :</span>
            <input
              className="w-72 h-7 lg:ml-6 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.vesselName}
              onChange={(e) => handleChange("vesselName", e.target.value)}
            ></input>
            <span className="lg:ml-8 mr-2 block">Shift No :</span>
            <input
              className="w-32 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.shiftNo}
              onChange={(e) => handleChange("shiftNo", e.target.value)}
            ></input>
            <span className="mx-2 block">Loaded by this truck :</span>
            <input
              readOnly
              className="w-32 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.loadedByThisTruck}
            ></input> */}
          </div>

          {/* 4th Line  */}
          {/* <div className="lg:flex mt-2">
            <span className="lg:ml-1 block">Deliveries Done :</span>
            <input
              className="w-32 h-7 lg:ml-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.deliveries}
              onChange={(e) => handleChange("deliveries", e.target.value)}
            ></input>
            <span className="lg:ml-20 mr-2 block">Cargo :</span>
            <input
              readOnly
              className="w-72 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.cargo}
            ></input>
            <span className="lg:ml-10 mr-2 block">Customer :</span>
            <input
              readOnly
              className="w-72 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.customerName}
            ></input>
          </div> */}

          {/* 4th line */}
          <div className="lg:flex mt-2">
            <span className="block lg:ml-1">Fuel Bal(In Tank) :</span>
            <input
              className="w-24 h-7 lg:ml-1 text-right lg:mr-1 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.fuelBal}
              type="number"
              onChange={(e) => {
                handleChange("fuelBal", e.target.value);
                handleChange(
                  "totalTank",
                  Number(e.target.value) + Number(formData?.approvedAmt),
                );
              }}
            ></input>
            <span className="mx-2 block lg:ml-6">Fuel Amt(Std) :</span>
            <input
              type="number"
              className="w-24 h-7 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.fulAmtStd ? formData?.fulAmtStd : 0}
              readOnly
              // onChange={(e) => handleChange("fulAmtStd", e.target.value)}
            ></input>
            <span className="lg:ml-4 block">Approved Amt :</span>
            <input
              type="number"
              className="w-24 text-right h-7 lg:ml-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.approvedAmt ? formData?.approvedAmt : 0}
              onChange={(e) => {
                if (Number(e.target.value) <= Number(formData?.fulAmtStd)) {
                  handleChange("approvedAmt", e.target.value);
                  handleChange(
                    "totalTank",
                    Number(e.target.value) + Number(formData?.fuelBal),
                  );
                } else {
                  alert("Approved Amount can not be greater than Fuel Amount")
                }
              }}
              onBlur={() => {
                if (Number(formData?.approvedAmt) > Number(formData?.fulAmtStd)) {
                  alert("Approved Amount can not be greater than Fuel Amount")
                  handleChange("approvedAmt", formData?.fulAmtStd);
                  handleChange(
                    "totalTank",
                    Number(formData?.fulAmtStd) + Number(formData?.fuelBal),
                  );
                }
              }}
            ></input>
            <span className="lg:ml-4 block">Total(Tank) :</span>
            <input
              className="w-24 h-7 lg:ml-2 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.totalTank}
              type="number"
              readOnly
            ></input>
            <span className="lg:ml-4 block">Previous KM :</span>
            <input
              className="w-24 h-7 lg:ml-2 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.previousKm}
              type="number"
              readOnly
            ></input>
            <span className="lg:ml-2 block">Current KM :</span>
            <input
              type="text"
              className="lg:ml-2 w-24 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.currentKm}
              // onChange={(e) => handleChange("currentKm", e.target.value)}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only digits
                if (/^\d*$/.test(value)) {
                  handleChange("currentKm", value);
                }
              }}
              onKeyDown={(e) => {
                // Block "e", "E", "+", "-", ".", etc.
                if (["e", "E", "+", "-", "."].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onBlur={() => {
                if (
                  Number(formData?.currentKm) < Number(formData?.previousKm)
                ) {
                  alert("Current Km must not be less than previous Km");
                  handleChange("currentKm", "");
                  return;
                }
              }}
            ></input>

            <input
              type="checkbox"
              className="w-4 h-4 mt-2 lg:ml-6"
              checked={formData?.fuelFitted}
              onChange={() => handleChange("fuelFitted", !formData?.fuelFitted)}
            ></input>
            <span className="block lg:ml-2 mt-2">Fuel Lock fitted</span>

            {/* <span className="lg:ml-10 block">
              Contract cargo quantity(Weight) :
            </span>
            <input
              type="number"
              className="w-32 h-7 text-right pr-2 lg:ml-1 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.contractCargoQty}
              readOnly
            ></input> */}
          </div>

          {/* 5th line */}

          {/* 6th line */}
          <div className="lg:flex mt-2">
            <span className="block">From Station:</span>
            <Select
              className="w-80 lg:ml-7"
              value={
                formData?.fromStation
                  ? {
                      value: formData?.fromStation,
                      label: formData?.fromStation,
                    }
                  : { value: "", label: "Select From Station" }
              }
              onChange={(e) => {
                if (e.value !== "") {
                  getCurrencyUponFromStation(e.value);
                  getFuelRateUponFromStation(e.value);
                  handleChange("fromStation", e.value);
                } else {
                  handleChange("fromStation", e.value);
                }
              }}
              options={[
                { value: "", label: "Select From Station" },
                ...formData?.fromStationList?.map((item) => ({
                  value: item.FUELLOCATIONNAME,
                  label: item.FUELLOCATIONNAME,
                })),
              ]}
            ></Select>

            <span className="mx-2 block">Fuel Rate :</span>
            <input
              readOnly
              className="w-24 h-7 border text-right border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.fuelRate}
            ></input>
            <span className="mx-2 block">Currency :</span>
            <input
              readOnly
              className="w-24 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.currency}
            ></input>
            <span className="mx-2 block">Exch Rate :</span>
            <input
              readOnly
              className="w-24 h-7 text-right border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.exchRate}
            ></input>
            <span className="lg:mt-2 ml-5 block">Previous Seal No :</span>
            <input
              readOnly
              className="w-24 h-7 lg:mt-2  lg:ml-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.previousSealNo}
            ></input>

            <span className="lg:mt-2 ml-2 block">Seal No :</span>
            <input
              type="text"
              className="w-24 h-7 lg:mt-2  lg:ml-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.sealNo}
              onChange={(e) => handleChange("sealNo", e.target.value)}
            ></input>
          </div>

          <div className="lg:flex mt-2">
            <span className="block">Narration :</span>
            <textarea
              className="lg:w-[485px] h-16 lg:ml-11 resize-none w-[95%] border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.narration}
              onChange={(e) => handleChange("narration", e.target.value)}
            ></textarea>
          </div>
        </div>
      </section>

      <section className="print-section">
        <main className="relative my-2  mx-[50px] w-[750px] h-[942px] bg-slate-50 p-[10px] text-[10px]">
          <div className="flex flex-col justify-end text-right">
            <p className="font-bold">{formData?.companyList?.ORGNAME}</p>
            <p className="font-bold">{formData?.companyList?.ADDRESS1}</p>
            <p className="font-bold">{formData?.companyList?.ADDRESS2}</p>
            <p className="font-bold">{formData?.companyList?.ADDRESS3}</p>
            <p className="font-bold">{formData?.companyList?.CITY}</p>
            <p className="font-bold">{formData?.companyList?.COUNTRY}</p>
          </div>

          <section className="border-[1.5px] border-blue-900 rounded-[10px] my-3 w-[100%] p-[10px]">
            <section>
              <h2 className="text-center font-bold text-[16px] underline">
                {menu}
              </h2>
            </section>
            <section className="flex gap-2">
              <div className="flex gap-1">
                <h1 className="font-bold">Voucher No :</h1>
                <p className="w-[130px]">{formData?.fuelVoucherNo}</p>
              </div>
              <div className="flex gap-1">
                <h1 className="font-bold">Truck Reg :</h1>
                <p className="w-[130px]">{formData?.vehicle}</p>
              </div>
              <div className="flex gap-1">
                <h1 className="font-bold">Date to be Issued :</h1>
                <p className="w-[130px]">
                  {" "}
                  {moment(formData?.Date).format("DD/MM/YYYY")}
                </p>
              </div>
            </section>
            <section className="flex gap-2">
              <div className="flex gap-1">
                <h1 className="font-bold">Journey No :</h1>
                <p className="w-[130px]"> {formData?.journeyNo}</p>
              </div>
              <div className="flex gap-1">
                <h1 className="font-bold ml-1">Route :</h1>
                <p className="w-[130px]"> {formData?.from}</p>
              </div>
              <div className="flex gap-1">
                <h1 className="font-bold ml-5">To :</h1>
                <p className="w-[130px]"> {formData?.to}</p>
              </div>
            </section>
            <section className="flex gap-2">
              <div className="flex gap-1">
                <h1 className="font-bold">Fuel Qty :</h1>
                <p className="w-[100px]"> {formData?.standardQty}</p>
              </div>
              <div className="flex gap-1">
                <h1 className="font-bold ml-12">Driver Name :</h1>
                <p className="w-[130px]"> {formData?.driverName}</p>
              </div>
              <div className="flex gap-1">
                <h1 className="font-bold">Passport :</h1>
                <p className="w-[130px]"> {""}</p>
              </div>
            </section>
            <section className="flex gap-2">
              <h1 className="font-bold">Location :</h1>
              <p>{formData?.fromStation}</p>
            </section>
            <section className="flex gap-2">
              <h1 className="font-bold">Narration :</h1>
              <p>{formData?.narration}</p>
            </section>
            <section className="flex gap-32">
              <div className="flex flex-col">
                <h1 className="font-bold">Voucher Processed</h1>
                <p>________</p>
              </div>
              <div className="flex flex-col">
                <h1 className="font-bold">Voucher Approved</h1>
                <p>________</p>
              </div>
              <div className="flex flex-col">
                <h1 className="font-bold">Driver Sign</h1>
                <p>________</p>
              </div>
            </section>
          </section>
          <section className="text-center my-[100px]">
            <h1>Powered by Genius Business System</h1>
            <h1>Marstrack ERP</h1>
            <h1>www.gbsafrica.net</h1>
          </section>
        </main>
      </section>
    </div>
  );
};

export default FuelAllocation;
